import React, { useState } from "react";
import Swal from "sweetalert2";
import { API_BASE } from "../config";
import { apiFetch } from "../utilities/apiFetch";
import { ACCIONES_CASO, MIN_JUSTIFICACION, EJEMPLO_JUSTIFICACION } from "../utilities/casosPlantel";

// Ventana del Historial: el cajero valido esta orden con el pago que en realidad hizo otro alumno. El pago pasa a la
// orden PENDIENTE del otro alumno (por su folio) y esta regresa a PENDIENTE. El servidor revisa todo
// (cMultipagosCasos.php, Mtd_Reasignar) y lo deja en la bitacora; Financieros lo ve en Seguimiento de casos.

const dinero = (n) => `$${Number(n || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
const estiloCampo = { padding: "8px", border: "1px solid #ccc", borderRadius: "4px", width: "100%", boxSizing: "border-box" };
const estiloEtiqueta = { display: "block", fontWeight: "bold", fontSize: "0.85rem", marginBottom: "4px" };

const ReasignarPago = ({ pago, onCerrar, onReasignado }) => {
  const [folio, setFolio] = useState("");
  const [motivo, setMotivo] = useState("");
  const [enviando, setEnviando] = useState(false);
  const listo = folio.trim().length >= 4 && motivo.trim().length >= MIN_JUSTIFICACION;

  const enviar = async () => {
    setEnviando(true);
    try {
      const res = await apiFetch(`${API_BASE}/wMultipagosReasignarPago.php`, {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id_orden: pago.id, folio_orden: folio.trim(), motivo: motivo.trim() }),
      });
      const json = await res.json();
      if (!json.success) { Swal.fire("No se pudo", json.message || "El servidor no aceptó el cambio.", "error"); return; }
      Swal.fire("Listo", json.message, "success");
      onReasignado();
    } catch (e) {
      Swal.fire("Error", "No hubo respuesta del servidor. Intenta de nuevo.", "error");
    } finally {
      setEnviando(false);
    }
  };

  return (
    <div role="dialog" aria-modal="true" aria-label="Reasignar el pago a otro alumno"
      style={{ position: "fixed", inset: 0, backgroundColor: "rgba(0,0,0,0.45)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 2000, padding: "16px" }}>
      <div style={{ backgroundColor: "#fff", borderRadius: "8px", padding: "20px", width: "100%", maxWidth: "520px" }}>
        <h4 style={{ marginTop: 0, color: "#003b5c" }}>Reasignar el pago a otro alumno</h4>
        <p style={{ fontSize: "0.9rem", margin: "0 0 6px 0" }}>
          Orden <b>{pago.id}</b> · {pago.conceptos} · <b>{dinero(pago.importe_total)}</b> · {pago.metodo_pago}{pago.folio_pago ? ` (${pago.folio_pago})` : ""}
        </p>
        <p style={{ fontSize: "0.9rem" }}>
          Úsalo solo si esta orden se validó con el pago que en realidad hizo <b>otro alumno</b>. {ACCIONES_CASO.REASIGNAR.explica}
        </p>
        <label htmlFor="reasignar-folio" style={estiloEtiqueta}>Folio de la orden del otro alumno (viene en su ficha)</label>
        <input id="reasignar-folio" inputMode="numeric" value={folio} onChange={(e) => setFolio(e.target.value.replace(/\D/g, ""))} maxLength={10}
          style={{ ...estiloCampo, marginBottom: "10px" }} />
        <p style={{ fontSize: "0.8rem", color: "#666", margin: "-4px 0 10px 0" }}>Si el otro alumno no tiene orden, genérale una en Cobrar por el mismo importe y vuelve con su folio.</p>
        <label htmlFor="reasignar-motivo" style={estiloEtiqueta}>Justificación (obligatoria)</label>
        <textarea id="reasignar-motivo" value={motivo} onChange={(e) => setMotivo(e.target.value)} rows={4} maxLength={1000}
          placeholder={EJEMPLO_JUSTIFICACION.REASIGNAR} style={estiloCampo} />
        {motivo.trim().length > 0 && motivo.trim().length < MIN_JUSTIFICACION && <p style={{ fontSize: "0.8rem", color: "#7a5c00" }}>Escribe por lo menos {MIN_JUSTIFICACION} caracteres.</p>}
        <div style={{ display: "flex", gap: "10px", justifyContent: "flex-end", marginTop: "12px" }}>
          <button onClick={onCerrar} className="btn-select" style={{ border: "1px solid #999", padding: "8px 14px", backgroundColor: "#fff", color: "#333" }}>Cancelar</button>
          <button onClick={enviar} disabled={!listo || enviando} className="btn-select validar"
            style={{ border: "none", padding: "8px 14px", opacity: (!listo || enviando) ? 0.45 : 1, cursor: (!listo || enviando) ? "not-allowed" : "pointer" }}>
            {enviando ? "Guardando..." : "Reasignar"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReasignarPago;
